export const FLIGHT_TYPE = 1
export const BUS_TYPE = 2
export const BLACK_CAR_TYPE = 3
export const EXPRESS_TYPE = 4
export const EXPRESS_HOME_TYPE = 5
